var _a;
import { eargoCustomEventSchemas } from '@/events/constants/custom-event-schemas.constant';
import { getEventTracker } from 'hx-analytics';
export var useEvents = (_a = getEventTracker(eargoCustomEventSchemas), _a.useEvents), trackCustom = _a.trackCustom;
